import { Text } from '@artprov/design-system'
import { HEADER_LABELS } from '../../../common/constants/labels'

/**
 * Componente para mostrar el título y subtítulo del informe
 */
const HeaderInfo = () => {
  return (
    <div className="mb-6">
      <Text variant="h6" className="text-primary-10 font-semibold">
        {HEADER_LABELS.TITLE}
      </Text>
      <Text variant="body2">{HEADER_LABELS.SUBTITLE}</Text>
    </div>
  )
}

export default HeaderInfo
